import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faBolt,
  faWallet,
  faLaptop,
  faGlobe,
  faBriefcase,
  faUsers,
  faPlane,
} from "@fortawesome/free-solid-svg-icons";
import NavBar from "../Navigation/NavBar";
import Footer from "../Footer/Footer";
import Services1 from "./IMG/Services1.png";
import Services2 from "./IMG/Services2.png";
import Services3 from "./IMG/Services3.png";
import Services4 from "./IMG/Services4.png";
import Services5 from "./IMG/Services5.png";
import Services6 from "./IMG/Services6.png";
import Services7 from "./IMG/Services7.png";
import Services8 from "./IMG/Services8.png";

import "./ServicesGallery.css";

const ServicesGallery = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const services = [
    {
      id: "permanent-staffing",
      title: "Permanent Staffing Solutions",
      image: Services1,
      icon: faStar,
      shortDesc: "Global recruitment connecting talent with opportunity",
    },
    {
      id: "temporary-staffing",
      title: "Temporary Staffing",
      image: Services2,
      icon: faBolt,
      shortDesc: "Flexible staffing solutions for your business needs",
    },
    {
      id: "payroll-management",
      title: "Payroll Management",
      image: Services3,
      icon: faWallet,
      shortDesc: "Accurate, timely compensation management",
    },
    {
      id: "dedicated-it",
      title: "Dedicated IT Resources",
      image: Services4,
      icon: faLaptop,
      shortDesc: "Expert IT professionals for your projects",
    },
    {
      id: "international-recruitment",
      title: "International Recruitment",
      image: Services5,
      icon: faGlobe,
      shortDesc: "Comprehensive global hiring solutions",
    },
    {
      id: "executive-search",
      title: "Executive Recruitment",
      image: Services6,
      icon: faBriefcase,
      shortDesc: "Top-tier leadership talent acquisition",
    },
    {
      id: "bulk-hiring",
      title: "Bulk Hiring Services",
      image: Services7,
      icon: faUsers,
      shortDesc: "Large-scale recruitment with precision",
    },
    {
      id: "visa-assistance",
      title: "Visa Assistance",
      image: Services8,
      icon: faPlane,
      shortDesc: "Fast and reliable visa processing",
    },
  ];

  const handleServiceClick = (serviceId) => {
    navigate(`/service-details/${serviceId}`);
  };

  return (
    <>
      <NavBar />

      {/* Hero Section */}
      <div className="gallery-hero">
        <div className="gallery-hero-content">
          <h1 className="gallery-hero-title">Our Services</h1>
          <p className="gallery-hero-subtitle">
            Explore our comprehensive range of staffing and recruitment solutions
          </p>
        </div>
      </div>

      {/* Services Gallery */}
      <div className="gallery-wrapper">
        <div className="gallery-container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div
                key={service.id}
                className="service-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="service-card-image-wrapper">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="service-card-image"
                  />
                  <div className="service-card-overlay"></div>
                  <div className="service-card-badge">
                    <FontAwesomeIcon icon={service.icon} />
                  </div>
                </div>

                <div className="service-card-content">
                  <h3 className="service-card-title">{service.title}</h3>
                  <p className="service-card-desc">{service.shortDesc}</p>
                  <div className="service-card-footer">
                    <button 
                      className="service-card-btn"
                      onClick={() => handleServiceClick(service.id)}
                    >
                      View Details
                      <span className="arrow">→</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="gallery-cta">
        <div className="gallery-cta-content">
          <h2>Ready to Find Your Perfect Solution?</h2>
          <p>
            Contact our team to discuss how we can support your staffing and recruitment needs
          </p>
          <button className="gallery-cta-btn">Get in Touch</button>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ServicesGallery;
